(function($, App, Utils, Components){
  "use strict";
	
  var logger = new Logger("BonusCardOrderComponent");

  Components.create('BonusCardOrderComponent', {

    Selectors: {
	  UserTypeSelect: '#customer-type',
	  EmptyOption: "#customer-type option[value='']",
      FormContainer: '#bonuscard-order-form-container',
	  CardSizeSelect: '.card-size-select',
	  OrderEntry: '.bonus-card-order-entry',
	  EntryQuantity: '.entry-quantity',
	  EntryCardSize: '.entry-card-size',
	  EntryComponent: '.entry-component',
	  EntrySize: '.entry-size',
	  PartialAmount: '#partial-amount',
	  TotalAmount: '#total-amount'
	},
	
	initUserTypeSelect: function() {
	  var _this = this;
	  $(_this.Selectors.UserTypeSelect).on('change', function () {
		logger.info('Selected user type: ' + this.value);
		 
		var $emptyOption = $(_this.Selectors.EmptyOption);
		if($emptyOption != null) {
			$emptyOption.remove();
		}
		
		var $formContainer = $(_this.Selectors.FormContainer);
		var url = $formContainer.data('url') 
		  + '?orderEntries=' + $formContainer.data('entries-number') 
		  + '&cardSizes=' + $formContainer.data('card-sizes')
		  + '&stampAmount=' + $formContainer.data('stamp-amount') 
		  + '&showTotal=' + $formContainer.data('show-total')
		  + '&maxQuantity=' + $formContainer.data('max-quantity')
		  + '&minCardSize=' + $formContainer.data('min-card-size')
		  + '&maxCardSize=' + $formContainer.data('max-card-size')
		  + '&submitUrl=' + $formContainer.data('submit-url');
		
		var ajaxData = {
	      params: {
    	    usertype: this.value
	      }
	    };
	    axios.get(url, ajaxData)
	      .then(function (response) {
	        $($formContainer).html(response.data);
			_this.initOrderEntries();
	      })
	      .catch(function (error) {
	        logger.d("Couldn't get bonuscard order form: ", error);
	      })
	  });
	},
	
	initOrderEntries: function() {
	  var _this = this;
	  var $formContainer = $(_this.Selectors.FormContainer);
	  $(_this.Selectors.EntryQuantity).each(function() {
		Utils.setInputFilter($(this), function(value) {
		  var maxQuantity = parseInt($formContainer.data('max-quantity'));
		  var quantityConstraintRespected = maxQuantity > 0 ? parseInt(value) <= maxQuantity : true; // no constraint maxQuantity is not set
		  return !value || (/^\d*$/.test(value) && quantityConstraintRespected); // allows digits only
		});
	  });
	  $(_this.Selectors.EntryCardSize).each(function() {
		Utils.setInputFilter($(this), function(value) {
		  var maxSize = parseInt($formContainer.data('max-card-size'));
		  var sizeConstraintRespected = maxSize > 0 ? parseInt(value) <= maxSize : true; // no constraint maxQuantity is not set
		  return !value || (/^\d*$/.test(value) && sizeConstraintRespected); // allows digits only
		});
	  });
	  $(_this.Selectors.OrderEntry).on('input', function () {
		_this.calculateAmounts();
	  });
	},
	
	calculateAmounts: function() {
	  var _this = this;
	  var $formContainer = $(_this.Selectors.FormContainer);
	  var $entries = $(_this.Selectors.OrderEntry);
	  var partialAmount = 0;
      var minConstraintRespected = true;
	  $entries.each(function() {
		var quantity = parseInt($(this).find(_this.Selectors.EntryQuantity).val());
		var size = parseInt($(this).find(_this.Selectors.EntryCardSize).val());
		var minSize = parseInt($formContainer.data('min-card-size'));
		quantity = isNaN(quantity) ? 0 : quantity;
		var isNumber = !isNaN(size);
		size = isNumber ? size : 0;
		partialAmount += quantity*size;
		if(size < minSize && isNumber) {
		  minConstraintRespected = false;
		}
	  });
	  var formattedPartial = (Math.round((partialAmount) * 100) / 100).toFixed(2);
	  if(partialAmount > 0 && minConstraintRespected) {
		formattedPartial = formattedPartial.replace(".", ",")
	    $(_this.Selectors.PartialAmount).attr('value', formattedPartial + '€');
	    var stampValue = parseFloat($formContainer.data('stamp-amount').replace(',', '.'));
	    var formattedTotal = (Math.round((partialAmount + stampValue) * 100) / 100).toFixed(2);
	    formattedTotal = formattedTotal.replace(".", ",")
	    $(_this.Selectors.TotalAmount).attr('value', formattedTotal + '€');
	  } else {
		$(_this.Selectors.PartialAmount).attr('value', null);
		$(_this.Selectors.TotalAmount).attr('value', null);
	  }
	},
	
    init: function() {
      this.initUserTypeSelect();
    }

  });

})(jQuery, window.App, window.App.Utils, window.App.Components);
